// holds user selection 
const FormState = 
 {
	reset : true, 
	config : {},
	userSettings: {},
	sectionItems : {},
	selectedProducts : [],
	
	isReset : function() {
		return this.reset; 
	},
	clearReset : function() {
		this.reset = false; 
	},
	resetOffer : function() {
		this.sectionItems = {};
		this.reset = true; 
	},
	resetOfferType : function() {
		this.config.Sections.forEach((sec) => {
			if (sec.filterOfferType) {
				this.clearSelection(sec.type, sec.key);
			}
		});
		this.reset = true; 
	},
	resetSection : function(section) {
		this.sectionItems[section] = [];
	},
	setSectionOption : function (section, options) {
		//console.log('setSectionOption', section, options );
		if (section==this.config.RegionSection ) {
			this.resetOffer();
		} 
		if (section==this.config.OfferTypeSection) {
			this.resetOfferType();
		}
		this.sectionItems[section] = options;
	},
	getSectionOption : function(section) {
		if (this.sectionItems[section]) {
			return this.sectionItems[section];
		} else {
			return [];
		}
	},
	setSelection : function (selectionType, selection, value) {
		this.setSectionOption(selection, value);
	},
	clearSelection : function (selectionType, selection ) {
		// hack 
		//console.log(selectionType, selection )
		if (selection==this.config.RegionSection ) {
			this.resetOffer();
		} else if (selection==this.config.OfferTypeSection) {
			this.resetOfferType();
		} else {
			this.setSectionOption(selection, []);
		}
	},
	hasRegions: function () {
		return (this.config.RegionKeys && this.config.RegionKeys.length > 0)
	},
	getRegion : function() {
		var cmp = this.getSectionOption(this.config.RegionSection);
		if (Array.isArray(cmp) && cmp.length > 0) {
			return cmp[0].toLowerCase();
		} else {
			return null;
		}
	},
	getOfferType : function() {
		var ot = this.getSectionOption(this.config.OfferTypeSection);
		if(Array.isArray(ot) && ot.length > 0) {
			return ot[0].toLowerCase();
		} else {
			return null;
		}
	},
	addProduct : function (product) {
		if (!this.selectedProducts.includes(product)) {
			this.selectedProducts.push(product);
		}
	},
	removeProduct : function(product) {
		this.selectedProducts = this.selectedProducts.filter((sp) => {
			return sp != product 
		});
	},
	includesProduct : function(product) {
		return this.selectedProducts.includes(product);
	}
}		

export default FormState; 
